export default __webpack_public_path__ + "static/media/FG1.7b937c42.jpeg";